import { render, staticRenderFns } from "./exchange-list.vue?vue&type=template&id=587aed44&scoped=true&"
import script from "./exchange-list.vue?vue&type=script&lang=js&"
export * from "./exchange-list.vue?vue&type=script&lang=js&"
import style0 from "./exchange-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./exchange-list.vue?vue&type=style&index=1&id=587aed44&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "587aed44",
  null
  
)

export default component.exports